// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-static-cancel\" tabindex=\"-1\" id=\"cancelBtn\"> <i class=\"fa fa-close\"></i> <!-- ko text: _labels.CANCEL --><!-- /ko --> </a>";
// Exports
export default code;